import { FaApple } from "react-icons/fa";
import { Flex, Text } from "@chakra-ui/react";

import { appStoreUrl } from "../../constants";

const SIZES = {
    md: { h: "42px", pl: "13px", pr: "16px", gap: "9px", apple: 22, top: "9px", store: "17px", radius: "9px" },
    lg: { h: "52px", pl: "16px", pr: "20px", gap: "11px", apple: 26, top: "10px", store: "20px", radius: "11px" },
};

// Apple's official "Download on the App Store" lockup — black badge, legible in both themes.
const AppStoreBadge = ({ onClick, size = "md", campaign = "homepage_hero" }) => {
    const s = SIZES[size] || SIZES.md;
    return (
        <Flex
            as="a"
            href={appStoreUrl(campaign)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
            align="center"
            gap={s.gap}
            h={s.h}
            pl={s.pl}
            pr={s.pr}
            bg="#000"
            border="1px solid rgba(255,255,255,0.22)"
            borderRadius={s.radius}
            display="inline-flex"
            transition="transform 0.18s ease, box-shadow 0.18s ease"
            boxShadow="0 1px 3px rgba(0,0,0,0.25)"
            _hover={{ transform: "translateY(-1px)", boxShadow: "0 6px 18px rgba(0,0,0,0.28)" }}
            aria-label="Download on the App Store"
        >
            <FaApple size={s.apple} color="#fff" style={{ marginTop: "-2px" }} />
            <Flex direction="column" gap="1px" lineHeight={1}>
                <Text fontSize={s.top} color="rgba(255,255,255,0.92)" fontFamily="body" letterSpacing="0.02em">
                    Download on the
                </Text>
                <Text fontSize={s.store} color="#fff" fontFamily="body" fontWeight={500} letterSpacing="-0.02em" lineHeight={1.05}>
                    App Store
                </Text>
            </Flex>
        </Flex>
    );
};

export default AppStoreBadge;
